/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  price: ModelRegistry['price'];
}

export interface BookingPriceSummarySignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingPriceSummaryComponent extends Component<BookingPriceSummarySignature> {
  @cached
  get price(): ModelRegistry['price'] {
    return this.args.price;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Summary': typeof UiBookingPriceSummaryComponent;
  }
}
